/**
 * MODULE: _shared/frontend-shell/src/components/assistant/riskAlertActionUtils.ts
 * PURPOSE: Normalize risk-alert suggested_actions (string legacy or structured) [2.2.1254].
 * PUBLIC_API: riskAlertActionLabel, normalizeRiskAlertAction
 * AGENT_SAFETY: SAFE
 */

import type { AssistantContextAction } from '@shared/lib/frontend/api/assistantContextApi';
import {
  advisorChipContextAction,
  type AdvisorChipEntity,
} from './assistantContextAdvisorChipAction';

export function riskAlertActionLabel(action: string | AssistantContextAction): string {
  return (typeof action === 'string' ? action : action.label || '').trim();
}

/** Prefer backend structured actions; fall back to label-regex routing for legacy strings. */
export function normalizeRiskAlertAction(
  action: string | AssistantContextAction,
  entity?: AdvisorChipEntity,
): AssistantContextAction {
  if (typeof action !== 'string') {
    return action;
  }
  return advisorChipContextAction(action, entity);
}
